var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.5 34.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707070;}.cls-2{fill:#6e6e6e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.25,34.5A17.25,17.25,0,1,1,34.5,17.25,17.27,17.27,0,0,1,17.25,34.5Zm0-33.5A16.25,16.25,0,1,0,33.5,17.25,16.27,16.27,0,0,0,17.25,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.25,25.41a.53.53,0,0,1-.3-.09L14.83,24c-5.72-3.7-5.72-6.41-5.72-7.43A4.46,4.46,0,0,1,17.25,14a4.46,4.46,0,0,1,8.14,2.52c0,1,0,3.73-5.72,7.43l-2.12,1.37A.55.55,0,0,1,17.25,25.41ZM13.57,13.17a3.35,3.35,0,0,0-3.35,3.35c0,.86,0,3.13,5.21,6.49l1.82,1.18L19.07,23c5.21-3.36,5.21-5.63,5.21-6.49a3.35,3.35,0,0,0-6.51-1.12.56.56,0,0,1-.52.37h0a.56.56,0,0,1-.53-.37A3.35,3.35,0,0,0,13.57,13.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLine);
export default __webpack_public_path__ + "static/media/heart_line.52bb9ff06a51b69a7196840174bdab27.svg";
export { ForwardRef as ReactComponent };